export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10774.fb5f694e.jpg";